import React, { FunctionComponent } from 'react';
import InlineTooltip from './InlineTooltip';

interface OwnProps {
  tip: string;
}

type Props = OwnProps;

const DetailTooltip: FunctionComponent<Props> = ({ tip }) => (
  <InlineTooltip icon="file alternate" tip={tip} />
);

export default DetailTooltip;
